import { connect } from 'react-redux';
import BlockAfterHours from '../components/block-after-hours';

const mapStateToProps = state => ({
  view: state.gantt.view,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(BlockAfterHours);
